import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { analytics } from '../dashboard.data';
import {select, Store} from "@ngrx/store";
import { Observable, Subscription } from 'rxjs';
import { Dashboard } from 'src/app/state/dashboard';
import { DashboardSelector } from 'src/app/state/dashboard.selector';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html'
})
export class AnalyticsComponent implements OnInit, OnDestroy {
  public analytics: any[] = [];
  public showXAxis = true;
  public showYAxis = true;
  public gradient = false;
  public showLegend = false;
  public showXAxisLabel = false;
  public xAxisLabel = 'Year';
  public showYAxisLabel = false;
  public yAxisLabel = 'Profit';
  public colorScheme:any = {
    domain: ['#283593', '#039BE5', '#FF5252']
  }; 
  public autoScale = true;
  public roundDomains = true;
  @ViewChild('resizedDiv') resizedDiv!:ElementRef;
  public previousWidthOfResizedDiv:number = 0; 



  public years: Array<number>;
  public currentYear: number;
  dataChart$: Observable<Dashboard> = this.store.pipe(select(DashboardSelector));
  dataChartUpdating: any[];

  profitCurrentYearSubcription: Subscription

  yearUpdated: boolean = false;

  constructor(private appService: AppService, private store: Store,
                private dashboardService: DashboardService) { }

  ngOnInit() {
    
    this.years = this.appService.getLastTenYears();
    
    this.currentYear = new Date().getFullYear();

  }

  onSelect(year:any) {

    this.currentYear = year;

    console.log(year);

    let obj = {
      idUser: JSON.parse(sessionStorage.getItem("user")!).id,
      year: year
    }
   
    this.profitCurrentYearSubcription = this.dashboardService.profitCurrentYear(obj).subscribe((data: any) => {

      this.yearUpdated = true;

      this.dataChartUpdating = data['profitInCurrentYear'];

    })


  }

  ngAfterViewChecked() {    
    if(this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth){
      this.analytics = [...analytics];
    }
    this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
  }

  ngOnDestroy(): void {
    
    if(this.yearUpdated) {

      this.profitCurrentYearSubcription.unsubscribe();

    }

  }

}